<template>
  <v-app>
    <LibHeader />
    <slot></slot>
    <LibFooter />
    <v-overlay style="z-index: 9999999999" :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- wspólne okienko z komunikatem -->
    <v-dialog v-model="dialog.show" width="500" content-class="rounded-xl">
      <v-card>
        <v-card-title>
          {{ dialog.title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          <div v-html="dialog.text"></div>
          <div class="btn-cont-dialog">
            <v-btn
              title="OK"
              aria-label="OK"
              color="primary"
              rounded
              large
              depressed
              @click="$store.commit('layout/hideDialog')"
            >
              OK
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- wspólne okienko z zapytaniem -->
    <v-dialog v-model="askDialog.show" width="500" content-class="rounded-xl">
      <v-card>
        <v-card-title>
          {{ askDialog.title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          <span v-html="askDialog.text"></span>
          <div class="btn-cont-dialog">
            <v-btn
              :title="askDialog.noLabel"
              :aria-label="askDialog.noLabel"
              color="primary"
              rounded
              outlined
              large
              @click="$store.commit('layout/hideAskDialog')"
            >
              {{ askDialog.noLabel }}
            </v-btn>
            <v-btn
              :title="askDialog.yesLabel"
              :aria-label="askDialog.yesLabel"
              color="primary"
              v-if="askDialog.yesClick"
              @click="askDialog.yesClick"
              rounded
              large
              depressed
            >
              {{ askDialog.yesLabel }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- powiadomienia -->
    <snackbar-notification v-if="isLogin"></snackbar-notification>
    <CookieBanner></CookieBanner>
  </v-app>
</template>

<script>
import LibHeader from "@/components/library/layout/LibHeader.vue";
import LibFooter from "@/components/library/layout/LibFooter.vue";
import { mapGetters } from "vuex";
import SnackbarNotification from "@/components/SnackbarNotification";
import offlineStoreDetect from "@/pwa/offline-store-detect";
import CookieBanner from "../components/CookieBanner.vue";

export default {
  name: "LayoutPublic",
  components: { SnackbarNotification, LibHeader, LibFooter, CookieBanner },
  computed: {
    ...mapGetters({
      overlay: "layout/getOverlay",
      dialog: "layout/getDialog",
      askDialog: "layout/getAskDialog"
    })
  },
  data: () => {
    return {
      firstTime: true
    };
  },
  mounted() {
    offlineStoreDetect(this.$store);
  }
};
</script>
